// lib
declare var KeyboardEvent, InputEvent;

// elvispos
import { Keyboard } from './keyboard';
import { Helpers, Logger } from 'ngx-elvis-ds';

export class KeyboardInput {

  inputID: string = Helpers.hash();

  constructor(
    public keyboard: Keyboard,
    public input: any
  ) {
    if (this.keyboard.formName === 'maintenanceForm') {
      input.layout = 'keypad';
    } else {
      if (input.pattern === '\\d*') {
        input.layout = 'number';
      } else {
        input.layout = this.keyboard.keyboardLayouts[input.type] ? input.type : '_default_lower';
      }
    }
    input.addEventListener('focus', this.onFocus.bind(this));
    input.addEventListener('blur', this.onBlur.bind(this));
    input.addEventListener('keydown', this.onKeyDown.bind(this));
    // Logger.debug(this)
  }

  // private

  private checkSelectionSupport(type) {
    if (!['text', 'search', 'url', 'tel', 'password'].includes(type)) { return false; }
    return true;
  }

  private dispatchEvent(event, keyInfo) {
    if (!keyInfo.symbol) {
      return;
    }

    event = new KeyboardEvent(
      event,
      {
        key: keyInfo.symbol,
        code: 'Key' + keyInfo.symbol,
        keyCode: keyInfo.symbol.charCodeAt(0),
        which: keyInfo.symbol.charCodeAt(0),
        altKey: false,
        ctrlKey: false,
        shiftKey: false,
        metaKey: false,
        bubbles: true
      }
    );
    event.virtual = true;

    this.input.dispatchEvent(event);
    this.input.dispatchEvent(
      new InputEvent('input', {
        inputType: String.fromCharCode(event.keyCode)
      })
    );

    Helpers.fireEvent(this.input, 'change');
  }

  private onFocus(e) {
    if (!['\\d*'].includes(this.input.pattern)) {
      document.body.classList.add('memphis-keyboard-open');
    }

    this.keyboard.show(e.target.layout);

    this.keyboard.on('key', this.inputID, (keyInfo) => {
      this.dispatchEvent('keydown', keyInfo);
    });
  }

  private onBlur(e, isDismissable) {
    document.body.classList.remove('memphis-keyboard-open');
    
    if (document.forms && document.forms['paymentForm']) {
      const elmts = document.forms['paymentForm'].getElementsByTagName('input');

      if (elmts[0]) {
        setTimeout(() => {
          if (document.forms['paymentForm'] && document.forms.length === 1) {
            document.forms['paymentForm'].getElementsByTagName('input')[0].focus();
          }
        }, 50);
      }
    }

    if (document.forms && document.forms['inputDialogForm'] && this.keyboard.hostSelector === '#input-keypad-host') {
      const elmts = document.forms['inputDialogForm'].getElementsByTagName('input');

      if (elmts[0]) {
        setTimeout(() => {
          if (document.forms['inputDialogForm']) {
            document.forms['inputDialogForm'].getElementsByTagName('input')[0].focus();
          }
        }, 50);
      }
    }

    if (this.keyboard.dismissable) {
      this.keyboard.hide(e.target.layout);
    }

    this.keyboard.off('key', this.inputID, (keyInfo) => {
      this.dispatchEvent('keydown', keyInfo);
    });
  }

  private onKeyDown(e) {
    // If keydown is authentic, skip our internal update and let the default play out
    if (!e.virtual) { return; }
    e.preventDefault();

    const selectionSupported = this.checkSelectionSupport(this.input.type);

    if (e.key === 'prev') {
      let prevInput: HTMLInputElement = this.keyboard.form.querySelector(`input[tabindex="${this.input.tabIndex - 1}"]`);

      // if (!prevInput) {
      //   prevInput = this.keyboard.form.querySelector(`elv-input[tabindex="${this.input.tabIndex - 1}"]`);
      // }

      if (this.input.tabIndex > 0 && prevInput) {
        prevInput.focus();
      }

      return;
    }

    if (e.key === 'next') {
      let nextInput: HTMLInputElement = this.keyboard.form.querySelector(`input[tabindex="${this.input.tabIndex + 1}"]`);

      // if (!nextInput) {
      //   nextInput = this.keyboard.form.querySelector(`elv-input[tabindex="${this.input.tabIndex - 1}"]`);
      // }

      console.log(nextInput)

      if (this.input.tabIndex < this.keyboard.inputsCount && nextInput) {
        nextInput.focus();
      }

      return;
    }

    if (e.key === 'backspace') {
      if (!selectionSupported) {
        this.input.value = this.input.value.slice(0, -1);
      } else {
        const pos = this.input.selectionStart;
        const offset = this.input.selectionEnd - this.input.selectionStart ? 0 : 1;
        this.input.value = (
          this.input.value.substring(0, this.input.selectionStart - offset) +
          this.input.value.slice(this.input.selectionEnd)
        );
        this.input.setSelectionRange(pos - offset, pos - offset);
      }
      return;
    }

    if (e.key === 'set_lower') {
      this.input.layout = '_default_lower';
      this.keyboard.show('_default_lower');
      return;
    }

    if (e.key === 'set_upper') {
      this.input.layout = '_default_upper';
      this.keyboard.show('_default_upper');
      return;
    }

    if (e.key === 'close_keyboard') {
      this.input.blur();
      return;
    }

    if (e.key === 'enter') {
      this.keyboard.form.submit();
      return;
    }

    const update = e.key || String.fromCharCode(e.keyCode);

    if (!selectionSupported) {
      this.input.value += update;
    } else {
      // let pos = this.input.selectionStart;
      // let offset = this.input.selectionEnd - this.input.selectionStart ? 0 : 1;
      this.input.value =
        this.input.value.substring(0, this.input.selectionStart) +
        update +
        this.input.value.slice(this.input.selectionEnd, this.input.value.length);
    }
  }
}
